import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useVisibilityOnScroll = (): boolean => {
	const [isVisible, setIsVisible] = useState<boolean>(false);
	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

	useEffect(() => {
		const handleScroll = (): void => {
			const currentScroll = window.pageYOffset;
			const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
			// Use 18% for desktops and 20% for mobile or smaller devices
			const scrollLimitPercent = isDesktop ? 0.18 : 0.2;
			setIsVisible(currentScroll > maxScroll * scrollLimitPercent);
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [isDesktop, setIsVisible]);

	return isVisible;
};

export default useVisibilityOnScroll;
